
import Component from "vue-class-component"
import {Prop, Inject} from "vue-property-decorator"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import {SparklineChart} from "@/ui/chart/SparklineChart"
import {MetricHistory} from "@/cube/metric-data"
import {DateRange} from "@/DateRangeSelector"
import {DateRangeService} from "@/DateRangeService"
import AnimatedNumber from "@/ui/AnimatedNumber.vue"
import {WithAnalyticsNavigation} from "@/superannuation/WithAnalyticsNavigation"
import {PlanService} from "@/superannuation/PlanService"

@Component({components: {AnimatedNumber, ChangeRateWidget}})
export default class SuperScoreProgressWidget extends WithAnalyticsNavigation {
  @Prop()
  subtitle: string

  @Prop()
  metricData: MetricHistory

  @Prop()
  icon: string

  @Inject()
  dateRangeService: DateRangeService

  @Inject()
  planService: PlanService

  chart?: SparklineChart

  mounted() {
    this.$watch(
      () => this.metricData.end?.amount,
      () => {
        if (this.metricData.end) {
          if (this.chart) {
            this.chart.dispose()
          }
          this.chart = new SparklineChart(
            <HTMLElement>this.$el.querySelector(".chart"),
            this.metricData,
            (dateRange: DateRange) =>
              (this.dateRangeService.dateRangeSelector!.selected = dateRange)
          )
        }
      },
      {immediate: true}
    )

    this.$watch(
      () => this.metricData.dateRange,
      dateRange => {
        if (dateRange && this.chart) {
          this.chart.highlightSelectedRange(dateRange)
        }
      },
      {immediate: true}
    )
  }

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
  }

  get amount() {
    return this.metricData.end?.amount
  }
}
